
import VueCropper from 'vue-cropperjs'
import Vue from 'vue'
import 'cropperjs/dist/cropper.css'
Vue.component('vue-cropper', VueCropper)
